<script lang="ts">
  import type { OrganizationUser } from "@kontextwerk/control-web-client"
  import type { UserCreateExtensionStep } from "@kontextwerk/control-web-frame"
  import UsersTable from "@kontextwerk/control-web-frame/components/users/UsersTable.svelte"
  import type { OrgaViewFrameContext } from "../../../../context"
  import {
    INVITE_PERMISSION_SECTIONS,
    PERMISSION_DEFINITIONS,
    PERMISSION_SECTIONS,
  } from "../../../../_shared/_logic/permission-sections"
  import UserInviteWorkingHoursStep from "./_modules/user-invite-working-hours-step"

  const { viewFrameContext } = $props<{
    viewFrameContext: OrgaViewFrameContext
  }>()

  const inviteExtensionSteps = $derived<UserCreateExtensionStep[]>([
    {
      id: "working-hours",
      label: "Arbeitszeiten",
      description: "Arbeitszeiten direkt für den neuen Benutzer prüfen.",
      hideDefaultAction: true,
      snippet: inviteWorkingHoursStep,
    },
  ])
</script>

{#if viewFrameContext.organization}
  <UsersTable
    mode="organization"
    organization={viewFrameContext.organization}
    users={viewFrameContext.organization.users}
    currentUserId={viewFrameContext.currentUserId}
    actorRole={viewFrameContext.currentUserRole}
    actorPermissions={viewFrameContext.permissions}
    permissionSections={PERMISSION_SECTIONS}
    invitePermissionSections={INVITE_PERMISSION_SECTIONS}
    permissionDefinitions={PERMISSION_DEFINITIONS}
    {inviteExtensionSteps}
    onUsersChanged={(users: OrganizationUser[]) => void viewFrameContext.onUsersUpdated(users)}
  />
{/if}

{#snippet inviteWorkingHoursStep(ctx)}
  <UserInviteWorkingHoursStep {ctx} />
{/snippet}
